module.exports = __webpack_public_path__ + "img/gsb1.8ead0dab.png";